"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("./shared");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Box = _styledComponents["default"].div.withConfig({
  shouldForwardProp: _shared.shouldForwardProp
}).withConfig({
  displayName: "box__Box",
  componentId: "sc-1csenxr-0"
})(["background-position:center right;", ";"], _shared.defaultSystemProps);

Box.displayName = "Primitives.Box";
var _default = Box;
exports["default"] = _default;